import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { forwardRef } from 'react';
import { Container } from '../Container.js';
export const IconMagicDust = forwardRef((props, ref) => _jsx(Container, {
  "data-testid": "IconMagicDust",
  viewBox: "0 0 14 14",
  ref: ref,
  ...props,
  children: _jsx("path", {
    d: "M3.42 7a.52.52 0 1 0 1.04 0C4.46 5.6 5.6 4.44 7 4.44c.29 0 .52-.23.52-.52V3.9A.5.5 0 0 0 7 3.4 2.54 2.54 0 0 1 4.46.85a.52.52 0 1 0-1.04 0c0 1.4-1.14 2.54-2.54 2.54a.5.5 0 0 0-.52.52v.02c0 .29.23.52.52.52 1.4 0 2.54 1.14 2.54 2.54m9.72-.54a2.55 2.55 0 0 1-2.55-2.55.52.52 0 1 0-1.04 0A2.55 2.55 0 0 1 7 6.45a.5.5 0 0 0-.52.53V7c0 .28.23.52.52.52 1.4 0 2.55 1.14 2.55 2.55a.52.52 0 0 0 1.04 0 2.55 2.55 0 0 1 2.55-2.55c.29 0 .52-.24.52-.52v-.02a.5.5 0 0 0-.52-.53m-6.17 4.12a1.5 1.5 0 0 1-1.5-1.5.52.52 0 0 0-1.05 0c0 .82-.68 1.5-1.5 1.5a.5.5 0 0 0-.53.52v.02c0 .28.23.52.52.52.83 0 1.51.67 1.51 1.5a.52.52 0 0 0 1.04 0c0-.83.68-1.5 1.51-1.5.29 0 .52-.24.52-.52v-.02a.5.5 0 0 0-.52-.52"
  })
}));
IconMagicDust.displayName = 'IconMagicDust';